import classNames from 'classnames';
import Typography from 'components/gruenland/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { TYPOGRAPHY_PRODUCT_CARD_PRICE } from 'lib/typography';
import { useParams } from 'next/navigation';
import { Money } from 'types/entity/product';

interface Props {
  discountedPrice?: Money;
  price?: Money;
}

const Prices: React.FC<Props> = ({ price, discountedPrice }) => {
  const { locale } = useParams();

  const discountPercentage = Math.round(
    (((price?.centAmount as number) - (discountedPrice?.centAmount as number)) / (price?.centAmount as number)) * 100,
  );

  return (
    <>
      {discountedPrice ? (
        <div className="flex items-center gap-2">
          <Typography className={TYPOGRAPHY_PRODUCT_CARD_PRICE}>
            {CurrencyHelpers.formatForCurrency(discountedPrice, locale)}
          </Typography>
          <Typography className={classNames(TYPOGRAPHY_PRODUCT_CARD_PRICE, 'text-neutrals-gray line-through')}>
            {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
          </Typography>
          {price?.centAmount && discountedPrice.centAmount && (
            <Typography className={classNames(TYPOGRAPHY_PRODUCT_CARD_PRICE, 'text-accent-red')}>
              {`-${discountPercentage}%`}
            </Typography>
          )}
        </div>
      ) : (
        <Typography className={TYPOGRAPHY_PRODUCT_CARD_PRICE}>
          {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
        </Typography>
      )}
    </>
  );
};

export default Prices;
